'use client';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useContaAtiva } from '@/domain/auth/hooks/useContaAtiva';

/**
 * Writes the browser tab: "CosturAI" alone, or "CosturAI · <account>" once the active account
 * of the unified login is known. It cannot be the page metadata because the account is picked
 * after the page loads.
 */
export function DocumentTitle() {
  const { t } = useTranslation('common');
  const { nome } = useContaAtiva();
  const produto = t('produto.nome');

  useEffect(() => {
    document.title = nome === '' ? produto : t('produto.comFabrica', { produto, fabrica: nome });
  }, [t, produto, nome]);

  return null;
}
